export default __webpack_public_path__ + "static/media/ic_access.5a3b5c17.svg";